module.exports = __webpack_public_path__ + "img/content11.22a63ecd.png";